import { minLength, maxLength, integer } from '@vuelidate/validators';

export default {
    integer,
    minLength: minLength( 4 ),
    maxLength: maxLength( 4 )
};